<img *ngIf="print.jpeg" [src]="print.jpeg" class="clickable" height="150px" (click)="viewOriginal()">